
import * as React from 'react';
import { ITileProps } from '@uifabric/experiments/lib/Tile';
import { ControlFacet } from '../models/controls/ControlFacet';
import { defaultRenderComponentOption } from '../components/controls/defaultRenderComponentControlOption';
import { IComponentAsProps } from '@uifabric/utilities/lib/IComponentAs';
import { ISpecifiedItemProps } from '../components/decorators/selectors';

/**
 * Provides a way to override the data-binding and render behavior of an Item Tile.
 * @beta
 */
export const itemTileControl = new ControlFacet<{
  itemKey: string;
}, {
    /**
     * Override for the underlying Tile component.
     */
    tileAs: React.ComponentType<IComponentAsProps<ITileProps & ISpecifiedItemProps>>;
    /**
     * Override for the content rendered for the item name.
     */
    itemName: JSX.Element | null;
    /**
     * Override for the content rendered for the item activity.
     */
    itemActivity: JSX.Element | null;
  }>('itemTileControl', {
    tileAs: defaultRenderComponentOption<ITileProps & ISpecifiedItemProps>()
  });
